import React from "react";

import { Card, CardHeader, CardTitle, DefinitionList } from "../../styles";
import { formatObservedAt } from "../../utils/format";
import { ResolvedActionDetailProps } from "../types";
import { decisionDetailsOf } from "../utils/toWorkItem";

export const ResolvedActionDetail: React.FC<ResolvedActionDetailProps> = ({
  resolution: { action, resolvedAt },
}) => (
  <Card aria-label={`Decision on ${action.symbol}`}>
    <CardHeader>
      <CardTitle>{action.symbol}</CardTitle>
    </CardHeader>
    <DefinitionList>
      <dt>Decision</dt>
      <dd>Reconciled</dd>
      <dt>Details</dt>
      <dd>{decisionDetailsOf(action)}</dd>
      <dt>Open holdings</dt>
      <dd>{action.preview.openHoldings}</dd>
      <dt>Affected users</dt>
      <dd>{action.preview.affectedUsers}</dd>
      <dt>Recorded</dt>
      <dd>{formatObservedAt(resolvedAt)}</dd>
    </DefinitionList>
  </Card>
);
